import React, { useEffect, useState } from "react";
import { adminAxios } from "../api";
import { Package, MessageSquareQuote, ShoppingCart, IndianRupee, Truck, Loader2 } from "lucide-react";

const Stat = ({ icon: Icon, label, value, tint }) => (
  <div className="bg-white rounded-xl border border-slate-200 p-5 flex items-center gap-4">
    <div className={`w-12 h-12 rounded-lg flex items-center justify-center ${tint}`}><Icon className="w-6 h-6" /></div>
    <div>
      <div className="text-2xl font-semibold text-slate-900">{value}</div>
      <div className="text-sm text-slate-500">{label}</div>
    </div>
  </div>
);

const Dashboard = () => {
  const [stats, setStats] = useState(null);
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    adminAxios.get("/dashboard/stats").then((r) => setStats(r.data)).finally(() => setLoading(false));
  }, []);

  const cur = (n) => `₹${Number(n || 0).toLocaleString("en-IN")}`;

  if (loading) return <div className="flex justify-center py-20"><Loader2 className="w-8 h-8 text-slate-400 animate-spin" /></div>;

  return (
    <div>
      <h1 className="text-2xl font-semibold text-slate-900 mb-1">Dashboard</h1>
      <p className="text-slate-500 mb-6">Overview of your store</p>
      <div className="grid sm:grid-cols-2 lg:grid-cols-3 gap-4">
        <Stat icon={ShoppingCart} label="Total Orders" value={stats?.total_orders ?? 0} tint="bg-blue-100 text-blue-600" />
        <Stat icon={IndianRupee} label="Online Revenue (Paid)" value={cur(stats?.online_revenue)} tint="bg-emerald-100 text-emerald-600" />
        <Stat icon={Truck} label="COD Order Value" value={cur(stats?.cod_value)} tint="bg-amber-100 text-amber-600" />
        <Stat icon={Package} label="Products" value={stats?.products ?? 0} tint="bg-violet-100 text-violet-600" />
        <Stat icon={MessageSquareQuote} label="Testimonials" value={stats?.testimonials ?? 0} tint="bg-pink-100 text-pink-600" />
        <Stat icon={ShoppingCart} label="Paid Orders" value={stats?.paid_orders ?? 0} tint="bg-teal-100 text-teal-600" />
      </div>
    </div>
  );
};

export default Dashboard;
